// On its own host the admin app talks to the API on that host, so the session cookie stays there
export const API_URL: string =
  import.meta.env.VITE_ADMIN_API_URL ?? import.meta.env.VITE_API_URL
